import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getComposers } from '../../actions/filterActions';

const ComposerFilterComponent = (props) => {

    const dispatch = useDispatch()

    const [composerValue, setComposerValue] = React.useState("")

    const {error, loading, composers, message} = useSelector(state => state.composers)

    React.useEffect(()=>{
        const identifer = setTimeout(()=>{
            if (composerValue){
                dispatch(getComposers(composerValue, props.filterList, 1, 0))
            } else {
                dispatch(getComposers(" ", props.filterList, 1, 0))
            }
        }, 500)

        return () => { clearTimeout(identifer) }

    },[composerValue])


    const chooseHandler = (composer) => {
        if (props.filterList.filter(g => g[0] === composer.id && g[2] === props.componentId ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [composer.id, composer.title, props.componentId]]})
        } else {
                props.setFilterList((prevArr) =>
                prevArr.filter(item => item[0] !== composer.id)
            )
        }
        props.setLastChangedComponent(props.componentId)
        setComposerValue('')
    }


    return (
        <div className = "w-100 d-flex flex-column py-4">
            <div className = "w-100 d-flex position-relative px-3 px-md-0">
                <div className=' w-100 py-3 border-bottom border-1 border-info d-flex align-items-center'>
                    <input
                        type="text"
                        data-tooltip-id="new-tooltip"
                        data-tooltip-content="For more search options, press the filter button on the right!"
                        className="fs-5 ps-2 w-100 border-0 text-white search-input bg-backcolor"
                        placeholder="Search Composers..."
                        onChange={(e)=>{setComposerValue(e.target.value)}}
                        value={composerValue}
                    />
                </div>
            </div>
            {

                loading ?
                <div className='w-100 text-info position-relative p-2 rounded'
                    style={{zIndex:'1000'}}
                >Loading...</div> :
                composers && composers.length ?
                <div className = "w-100 position-relative mt-3 p-2 d-flex flex-wrap rounded"
                    style = {{color:"#333", zIndex:1000}}
                    >
                        {
                        composers.map((result) => (
                        <div
                            key = {result.id}
                            className =
                            {
                                props.filterList.some(component => component[0] === result.id && component[2] === props.componentId) ?
                                "p-1 col-4 col-md-3 col-lg-1 bg-blueazur rounded border border-2 border-backcolor" :
                                "p-1 col-4 col-md-3 col-lg-1 "
                            }
                            role = 'button'
                            onClick={()=>chooseHandler(result)}
                            >
                            <img
                                src = {`http://img.cugate.com/?o=member&i=${result.id}&s=600`}
                                className='w-100 border border-3 border-light rounded-circle'
                                alt = 'composer'
                                style={{
                                    aspectRatio:"1",
                                    objectFit: 'cover',
                                    objectPosition: 'top'
                                }}
                            />
                            <div
                                className = "py-1 px-1 text-info text-center text-wrap overflow-hidden"
                                role = "button"
                                style={{transition:"all 0.2s"}}
                                key = {result.id}
                                title={result.title}
                            >
                                {result.title}
                            </div>
                        </div>

                        ))
                        }
                </div> :
                message ?
                <div className='w-100 text-info position-relative p-2 rounded'>
                    {message}
                </div> : ""
            }
        </div>
    );
};

export default ComposerFilterComponent;